import React, { useRef } from "react";
import {
  renderRichText,
  StoryblokComponent,
  storyblokEditable,
} from "@storyblok/react";
import { InfoPanelModel } from "./InfoPanelModel";

import "./InfoPanel.css";
import Utils from "../../core/Utils/Utils";

const InfoPanel: React.FC<{ blok: InfoPanelModel }> = ({ blok }) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const isVideo = blok.media?.filename?.endsWith(".mp4");
  const bodyHTML = renderRichText(blok.body) || "";

  const autoplay =
    blok.videoProperties && blok.videoProperties.indexOf("autoplays") > -1;
  const muted =
    blok.videoProperties && blok.videoProperties.indexOf("muted") > -1;
  const loop =
    blok.videoProperties && blok.videoProperties.indexOf("loops") > -1;

  const handleVidoClick = () => {
    if (videoRef && videoRef.current) {
      videoRef.current.play();
    }
  };

  return (
    <div
      {...storyblokEditable(blok)}
      className={`info-panel ${blok.display}`}
      style={{ backgroundColor: blok.backgroundColor, color: blok.textColor }}
    >
      <div className="container">
        <div className="info-panel-immage">
          {isVideo && (
            <video
              onClick={handleVidoClick}
              autoPlay={autoplay}
              loop={loop}
              muted={muted}
              playsInline
              src={Utils.getCacheUrl(blok.media?.filename)}
              ref={videoRef}
              style={{ objectFit: "cover" }}
              onError={(e) => Utils.handleVideoError(e, blok.media.filename)}
            ></video>
          )}
          {!isVideo && blok.media?.filename && (
            <img
              src={Utils.getCacheUrl(blok.media.filename)}
              alt=""
              onError={(e) => Utils.handleImageError(e, blok.media.filename)}
            />
          )}
        </div>
        <div className="info-panel-content">
          <div className="title">{blok.title}</div>
          <div className="body">
            <div dangerouslySetInnerHTML={{ __html: bodyHTML }}></div>
          </div>
          <div className="action">
            {blok.button && blok.button.length > 0 && (
              <StoryblokComponent
                blok={blok.button[0]}
                key={blok.button[0]._uid}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoPanel;
